import { InView } from 'react-intersection-observer'
import { getFeatureObject } from 'src/utils/amplitude/getFeatureObject'
import { getStandardObject } from 'src/utils/amplitude/getStandardObject'
import { dispatchAmplitudeEvent } from 'src/utils/amplitude'
import { useGlobalContext } from 'src/components/contexts/GlobalContext'

import { useProductPageContext } from '../../contexts'
import HighlightCards from './HighlightCards'
import HighlightLevels from './HighlightLevels'
import UsefulnessSurvey from './UsefulnessSurvey'

import './product-details-highlight.scss'

const SPORTS_TO_SHOW_SKILL_BARS = [
  'Camping',
  'Escalada e Alpinismo',
  'Ski e Snowboard',
  'Trilha e Trekking',
  'Caminhada',
  'Corrida',
  'Trail Running',
  'Treino Cardio',
  'Musculação',
  'Funcional e Cross Training',
  'Pilates',
  'Yoga',
]

const ProductDetailsHighlight = () => {
  const { product } = useProductPageContext()
  const { pageData } = useGlobalContext()
  const showInThisSport = SPORTS_TO_SHOW_SKILL_BARS.includes(product.sport)

  if (
    !product.productHighlight?.levels?.length ||
    !product.productHighlight?.cards?.length ||
    !showInThisSport
  ) {
    return null
  }

  const { cards, levels } = product.productHighlight

  const sendPromoFeatureViewedEvent = () => {
    const eventData = {
      ...getStandardObject(pageData),
      ...getFeatureObject({
        locationOnPage: 'pdp',
        name: 'special products',
        section: 'component features',
      }),
    }

    dispatchAmplitudeEvent({ eventName: 'Product Feature Viewed', eventData })
  }

  return (
    <InView
      data-testid="product-details-highlight"
      className="product-details-highlight flex flex-col gap-8 mt-8"
      as="section"
      threshold={0.7}
      triggerOnce
      key={product.productId}
      onChange={(inView) => {
        if (inView) {
          sendPromoFeatureViewedEvent()
        }
      }}
    >
      {cards && <HighlightCards cards={cards} />}
      <HighlightLevels levels={levels} />
      <UsefulnessSurvey />
    </InView>
  )
}

export default ProductDetailsHighlight
